// src/mocks/mockDb.js
const deepClone = (x) => JSON.parse(JSON.stringify(x));

let slips = [
  {
    id: 101,
    month: "2025-12",
    userId: 1,
    hoTen: "Phạm Gia Lộc",
    phongBan: "Xưởng",
    kieuChamCong: "NGAY_2x",
    status: "PUBLISHED", // DRAFT | PUBLISHED | SIGNED | VERIFIED | REJECTED
    totalCong: 23.5,
    stats: {
      minutesTre: 15,
      minutesSom: 10,
      quenCham: 1,
      sundayCong: 2.0,
      tangCaHours: 6.0,
    },
    signature: null, // { name, imageDataUrl, signedAt }
    signatureEmployee: {
      imageDataUrl: null,
      signedAt: null,
    },
    signatureAdmin: {
      imageDataUrl: null,
      signedAt: null,
    },

    adminNote: null,
    payrollPdfUrl: null,
    snapshot: {
      daysInMonth: 31,
      daily: Array.from({ length: 31 }, (_, i) => {
        const day = i + 1;
        const isSunday = [1, 8, 15, 22, 29].includes(day);
        const cong = isSunday ? 1.0 : day % 6 === 0 ? 0.5 : 1.0;
        return {
          day,
          date: `2025-12-${String(day).padStart(2, "0")}`,
          sunday: isSunday,
          holiday: false,
          soCong: cong,
          soCongAm: cong >= 0.5 ? 0.5 : 0,
          soCongPm: cong >= 1.0 ? 0.5 : 0,
          tongVaoTre: day === 3 ? 15 : 0,
          tongRaSom: day === 10 ? 20 : 0,
          tongQuenCham: day === 12 ? 1 : 0,
        };
      }),
    },
  },
  {
    id: 102,
    month: "2025-12",
    userId: 2,
    hoTen: "Nguyễn Văn A",
    phongBan: "Văn phòng",
    kieuChamCong: "BUOI_2x2",
    status: "SIGNED",
    totalCong: 22.0,
    stats: {
      minutesTre: 0,
      minutesSom: 0,
      quenCham: 0,
      sundayCong: 0,
      tangCaHours: 2.5,
    },
    signature: {
      name: "Nguyễn Văn A",
      imageDataUrl: null,
      signedAt: "2025-12-25T09:10:00",
    },
    signatureEmployee: {
      imageDataUrl: null,
      signedAt: null,
    },
    signatureAdmin: {
      imageDataUrl: null,
      signedAt: null,
    },

    adminNote: null,
    payrollPdfUrl: null,
    snapshot: {
      daysInMonth: 31,
      daily: Array.from({ length: 31 }, (_, i) => ({
        day: i + 1,
        date: `2025-12-${String(i + 1).padStart(2, "0")}`,
        sunday: false,
        holiday: false,
        soCong: (i + 1) % 7 === 0 ? 0.5 : 1.0,
        soCongAm: 0.5,
        soCongPm: (i + 1) % 7 === 0 ? 0 : 0.5,
        tongVaoTre: 0,
        tongRaSom: 0,
        tongQuenCham: 0,
      })),
    },
  },
];

export const mockDb = {
  listAdmin({ month, status, keyword }) {
    let arr = slips.filter((s) => s.month === month);
    if (status && status !== "ALL")
      arr = arr.filter((s) => s.status === status);
    if (keyword) {
      const kw = keyword.toLowerCase();
      arr = arr.filter((s) => (s.hoTen || "").toLowerCase().includes(kw));
    }
    return deepClone(
      arr.map((s) => ({
        id: s.id,
        month: s.month,
        userId: s.userId,
        hoTen: s.hoTen,
        phongBan: s.phongBan,
        status: s.status,
        totalCong: s.totalCong,
        signedAt: s.signature?.signedAt || null,
      }))
    );
  },

  getById(id) {
    const s = slips.find((x) => x.id == id);
    if (!s) throw new Error("Not found");
    return deepClone(s);
  },

  getMy({ month, userId }) {
    const s = slips.find(
      (x) => x.month === month && x.userId === Number(userId)
    );
    return s ? deepClone(s) : null;
  },

  sign({ month, userId, name, imageDataUrl }) {
    const s = slips.find(
      (x) => x.month === month && x.userId === Number(userId)
    );
    if (!s) throw new Error("Not found");
    if (s.status !== "PUBLISHED")
      throw new Error("Phiếu không ở trạng thái PUBLISHED");
    s.signature = { name, imageDataUrl, signedAt: new Date().toISOString() };
    s.status = "SIGNED";
    return deepClone(s);
  },

  verify({ id, note }) {
    const s = slips.find((x) => x.id == id);
    if (!s) throw new Error("Not found");
    if (s.status !== "SIGNED")
      throw new Error("Chỉ verify khi phiếu đã SIGNED");
    s.status = "VERIFIED";
    s.adminNote = note || "OK";
    s.payrollPdfUrl = `/mock-pdf/payroll_${s.userId}_${s.month}.pdf`; // fake link
    return deepClone(s);
  },

  reject({ id, reason }) {
    const s = slips.find((x) => x.id == id);
    if (!s) throw new Error("Not found");
    s.status = "REJECTED";
    s.adminNote = reason || "Rejected";
    return deepClone(s);
  },
};
